// eventBus.js
import mitt from 'mitt'; // A tiny emitter lib

const eventBus = mitt();

export default eventBus;
